module.exports = __webpack_public_path__ + "static/media/edit-orange.2b6c9126.svg";